<template>
    <div>
        <top></top>
        <EditImg></EditImg>
    </div>
</template>
<script>
import Top from '../components/common/Top.vue'
import EditImg from '../components/EditImg.vue'
export default {
    components: {
        Top, EditImg
    }
}
</script>
<style scoped>
</style>
